'use client';

// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import NavLink from '@/components/Navigation/NavLink';

// styles
import styles from './MyListNav.module.scss';


const MyListNav = () => {

  return (
    <ul className={styles.my_list_nav}>
      <li><NavLink href="/my-list/shows/" className={styles.my_list_nav_link}>Shows</NavLink></li>
      <li><NavLink href="/my-list/videos/" className={styles.my_list_nav_link}>Videos</NavLink></li>
      <li><NavLink href="/my-list/continue-watching/" className={styles.my_list_nav_link}>Continue Watching</NavLink></li>
      <li><NavLink href="/my-list/viewing-history/" className={styles.my_list_nav_link}>Viewing History</NavLink></li>
    </ul>
  );
};

export default MyListNav;
